<kodit-list [items]="informacijaIsporukeList" [listConfig]="listConfig"></kodit-list>
